import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store';
import Vuetify from 'vuetify'

import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import {DatePicker} from "element-ui"
import 'element-ui/lib/theme-chalk/index.css';
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

import infiniteScroll from 'vue-infinite-scroll'

import VueAnalytics from 'vue-ua';

Vue.config.productionTip = false

Vue.use(Vuetify, {
    theme: {
        primary: '#007cc5',
        secondary: "#26AFDC",
        accent: colors.yellow.accent4,
        journal_color: '#26AFDC',
    }
})

locale.use(lang)
Vue.component(DatePicker.name, DatePicker)

Vue.use(infiniteScroll)

Vue.use(VueAnalytics, {
    appName: process.env.VUE_APP_NAME,
    appVersion: process.env.VUE_APP_VERSION,
    trackingId: process.env.VUE_APP_TRACKING_ID,
    vueRouter: router,
});

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
